export const toSentenceCaseWithSpaces = (str = '') => {
    if (!str || str.length < 2) {
        return '';
    }
    return str
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (char) => char.toUpperCase())
        .replace(/\s+(.)/g, (_, char) => ` ${char.toLowerCase()}`);
};
export const sanitizeForCsv = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    let sanitizedValue = value.trim();
    const firstChar = sanitizedValue.charAt(0);
    if (['=', '+', '-', '@', '|', '%'].includes(firstChar)) {
        sanitizedValue = `'${sanitizedValue}`; // Prefix with single quote to neutralize formula
    }
    return sanitizedValue.replace(/[\n\r",]/g, ' ');
};
